import { ComponentType } from 'react';

import {
  ReactPlugin,
  withAITracking
} from '@microsoft/applicationinsights-react-js';
import {
  ApplicationInsights,
  ITelemetryItem
} from '@microsoft/applicationinsights-web';

let reactPlugin: ReactPlugin;
let appInsights;

const initialize = (connectionString: string) => {
  reactPlugin = new ReactPlugin();
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      instrumentationKey: '',
      enableAutoRouteTracking: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      extensions: [reactPlugin as any],
      disableTelemetry: connectionString === 'development',
      disableInstrumentationKeyValidation: true
    }
  });
  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
    env.tags = env.tags || [];
    env.tags['ai.cloud.role'] = 'model-registry-fe';
  });
};

export default (Component: ComponentType<unknown>) =>
  withAITracking(reactPlugin, Component);
export { appInsights, initialize, reactPlugin };
